import { ReactComponent as SpinnerIcon } from 'img/icons/spinner.svg';
import React, { memo,ReactElement } from 'react';

import styles from './Spinner.css';

export const Spinner = memo(
    (): ReactElement => {
        return <SpinnerIcon className={styles.root} width={40} height={40} />;
    }
);

Spinner.displayName = 'Spinner';
